<template>
  <div>
    <el-row :gutter="10">
      <el-col>
        <el-form
          ref="form"
          size="small"
          :model="formData"
          :rules="rules"
          :disabled="disabled"
        >
          <el-row :gutter="10" class="my-4">
            <el-col>
              <div
                class="d-flex mb-2"
                style="font-size: 14px; font-weight: bold;"
              >
                <span>
                  {{
                    $l('form_label_laster_shortage_quantity') ||
                      '最后一次短装数量修改'
                  }}
                </span>
              </div>
            </el-col>
            <el-col>
              <vxe-grid
                ref="table"
                show-overflow
                highlight-hover-row
                :data="tableData"
                :columns="tableColumns"
                size="small"
                auto-resize
                resizable
                border
              >
              </vxe-grid>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="mt-2" v-if="!disabled">
            <el-col>
              <div style="font-size: 14px; font-weight: bold;">
                <span>
                  {{
                    $l('form_label_edit_shortage_quantity') || '短装数量修改'
                  }}
                </span>
              </div>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_shortageQuantity') || '短装数量'"
                prop="shortageQuantity"
              >
                <el-input-number
                  controls-position="right"
                  size="small"
                  style="width: 100%"
                  :min="-99999999"
                  :max="purchaseQty"
                  :step="1"
                  v-model="formData.shortageQuantity"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_remarks') || '短装原因'"
                prop="remarks"
              >
                <el-input
                  v-model="formData.remarks"
                  :placeholder="
                    $l('form_label_pl_remarks') || '请输入短装原因...'
                  "
                  type="textarea"
                  :rows="4"
                  maxlength="500"
                  show-word-limit
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: {},
  props: {
    disabled: { type: Boolean, default: false },
    isChange: { type: Boolean, default: false },
    amzPurchaseDetailCode: { type: String, default: '' },
    purchaseQty: { type: Number, default: 0 },
  },
  data() {
    return {
      formData: {},
      tableData: [],
      backDialogVisible: false,
      rules: {
        shortageQuantity: [
          {
            required: true,
            message: this.$l('form_label_pl_shortageQuantity') || '请输入短装数量',
            trigger: 'blur',
          },
        ],
      },
      tableColumns: [
        {
          title: this.$l('table_label_amzSkuNo') || 'SKU',
          field: 'amzSkuNo',
          headerAlign: 'center',
          align: 'center',
          width: 150,
        },
        {
          title: this.$l('table_label_ncNo') || 'NC',
          field: 'ncNo',
          headerAlign: 'center',
          align: 'center',
          width: 150,
        },
        {
          title: this.$l('table_label_amzPurchaseNo') || '采购单号',
          field: 'amzPurchaseNo',
          headerAlign: 'center',
          align: 'center',
          width: 150,
        },
        {
          title: this.$l('table_label_shortageQuantity') || '短装数量',
          field: 'shortageQuantity',
          headerAlign: 'center',
          align: 'center',
          width: 80,
        },
        {
          title: this.$l('table_label_shortageQuantity_remarks') || '短装原因',
          field: 'remarks',
          headerAlign: 'center',
          align: 'center',
          minWidth: 150,
        },
        {
          title:
            this.$l('table_label_shortageQuantity_createDate') || '修改日期',
          field: 'createDate',
          headerAlign: 'center',
          align: 'center',
          minWidth: 150,
        },
        {
          title:
            this.$l('table_label_shortageQuantity_createByName') || '修改人',
          field: 'createByName',
          headerAlign: 'center',
          align: 'center',
          minWidth: 150,
        },
      ],
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.amzPurchaseDetailCode) return
      this.$api
        .ecomAmzFtyPurchasShortageLatestListApi({
          amzPurchaseDetailCode: this.amzPurchaseDetailCode,
        })
        .then((res) => {
          this.tableData = res.body?.data || []
        })
    },

    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      const params = {
        ...this.formData,
        amzPurchaseDetailCode: this.amzPurchaseDetailCode,
      }
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzFtyPurchaseDetailUpdateShortageApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || res.msg,
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },

    cancel() {
      if (this.disabled) return this.close()
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped></style>
